module.exports = __webpack_public_path__ + "static/media/megaman_0.01adbd0b.png";